import './bootstrap';
import initClient from './initClient';

initClient();
